import { AfterViewInit, Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { Location } from '@angular/common'
import { LocationData, LocationOptions } from '../location-picker/location-picker.component';
import { MapControls } from '../../utilities/MapControls/MapConrols';
import { QuickDialog } from '../../utilities/Dialog/QuickDialog';
import { MatDialog } from '@angular/material';
import { Destination } from '../../DataStructures/Destination/Destination';
import { Trip } from '../../DataStructures/Trip/Trip';
import { Area } from '../../DataStructures/Area/Area';
import { DirectionsService } from '../../utilities/DirectionsService/DirectionsService';
import { ActivatedRoute } from '@angular/router';
declare var google: any;
@Component({
  selector: 'passenger-map-screen',
  templateUrl: './passenger-map-screen.component.html',
  styleUrls: ['./passenger-map-screen.component.css']
})
export class PassengerMapScreenComponent implements OnInit, AfterViewInit {
  jaLat = 18.1350138;
  jaLng = -77.1981928;
  zoom  = 17;
  @ViewChild('map') mapReference: ElementRef;
  @Output() locationSelected = new EventEmitter<Array<LocationData>>();
  search;
  locationData;
  autocomplete;
  locAddress: string;
  options: LocationOptions;
  constructor(private directions:DirectionsService, private _location: Location, public mapControls: MapControls,private route:ActivatedRoute, private dialog: MatDialog) {

  }


  ngOnInit() {
  }

  backClicked() {
    this._location.back();
  }

  submit() {
    if (!this.locationData) {
      new QuickDialog(this.dialog).InfoDialog("Please search for your drop-off address or drop the pin on your street or community.", "No Location Entered", "OK");
    } else {
      sessionStorage.setItem('locationdata', JSON.stringify(this.locationData));
      this.backClicked();
    }
  }

  ngAfterViewInit(): void {

    this.defaultLocation();

  }

  async defaultLocation(){
    if(this.route.snapshot.queryParams.lat && 
    this.route.snapshot.queryParams.lng &&
    this.route.snapshot.queryParams.address){
      this.jaLat = Number(this.route.snapshot.queryParams.lat);
      this.jaLng = Number(this.route.snapshot.queryParams.lng);
      this.locationData = {
        lat:this.jaLat,
        lng:this.jaLng,
        address:this.route.snapshot.queryParams.address,
        id:null
      }
    }else{
      try{
        let coords : any = await this.mapControls.getUserLocation();
        this.jaLat = coords.latitude;
        this.jaLng = coords.longitude;
      }catch(e){
        
      }
    }
    this.mapControls.initialize(this.mapReference);
    this.mapControls.createMapAndCenterOnLoaction(this.jaLat, this.jaLng, true, false);
    this.mapControls.map.setZoom(this.zoom);
    this.latLngOnClick()
    this.initAutoComplete();
  }

  initAutoComplete() {
    this.search = document.getElementById('search');
    this.autocomplete = new google.maps.places.Autocomplete(this.search, this.getOptions());
    this.regAutoCompleteListener();
  }

  regAutoCompleteListener() {

    this.mapControls.registerAutcompleteListener('place_changed', this.autocomplete).then(place => {
      var loc = new LocationData("", place.geometry.location.lat(), place.geometry.location.lng());
      this.validateLocation(loc, true);
      this.regAutoCompleteListener();
    }).catch(e => {
      this.regAutoCompleteListener();
    })
  }

  latLngOnClick() {

    this.mapControls.registerListener('click').then(e => {
      this.latLngOnClick();
      var loc = new LocationData("", e.latLng.lat(), e.latLng.lng());
      this.validateLocation(loc, false);
    }).catch(e => {
      this.latLngOnClick();
    })
  }

  validateLocation(locationData: LocationData, fromSearch: boolean, prevAddress = null) {

    var dest = new Destination(locationData.lat, locationData.lng, "", null)
    var validTrip = new Trip(this.getTestOrigins(), new Area(1, "User Selected Location",null, [dest], false), [], null);
    var invalid = false;
    validTrip.getDirectionsGoogle(this.directions, null).then(res => {
      locationData.address = res.directions.routes[0].legs[0].end_address;
      locationData.lat = res.directions.routes[0].legs[0].end_location.lat();
      locationData.lng = res.directions.routes[0].legs[0].end_location.lng();
      locationData.id = locationData.id;
      this.locationValid(locationData, fromSearch, prevAddress);
    }).catch(e => {
      this.locationInvalid();
    })
  }



  locationValid(locationData: LocationData, fromSearch: boolean, prevAddress = null) {
    this.locAddress = this.decideLocAddress(prevAddress, locationData.address);
    locationData.address = this.locAddress;
    this.mapControls.addMarker(new google.maps.LatLng(locationData.lat, locationData.lng), "", true, 'register-marker.png').addListener('click', function () {
    });
    if (fromSearch) {
      this.mapControls.centerMapOnLoaction(new google.maps.LatLng(locationData.lat, locationData.lng));
      this.mapControls.map.setZoom(this.zoom);
    }
    this.locationData = locationData;
    console.log(locationData);
    this.locationSelected.emit([locationData]);
  }

  locationInvalid() {
    new QuickDialog(this.dialog).InfoDialog("Location Not Allowed, Please select a location within Jamaica", "Invalid Location", "OK");
    let jaLat = 18.9350138;
    let jaLng = -77.7981928;

    this.mapControls.clearMarkers();
    this.search.value = null;
    this.mapControls.centerMapOnLoaction(new google.maps.LatLng(this.jaLat, this.jaLng));
    this.mapControls.map.setZoom(this.zoom);
  }

  private decideLocAddress(prevAddress = null, end_address) {
    return end_address;
  }

  getOptions() {
    var defaultBounds = new google.maps.LatLngBounds(
      new google.maps.LatLng(17.546889258900055, -78.54058735825066),
      new google.maps.LatLng(18.591323377300697, -76.02471821762566)
    )
    return {
      bounds: defaultBounds
    };
  }

  getTestOrigins() {


    var destination = new Destination(18.0418764, -76.7772811, "", null);
    var destinations = new Array<Destination>();
    destinations.push(destination);
    return new Area(
      -1,
      "Russell Heights, Kingston, Jamaica",
      null,
      destinations,
      true
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/passenger-map-screen/passenger-map-screen.component.ts